import React from 'react';
import { clsx } from 'clsx';

interface StatusBadgeProps {
  isLive: boolean;
  className?: string;
}

export const StatusBadge: React.FC<StatusBadgeProps> = React.memo(({ isLive, className }) => {
  return (
    <span
      className={clsx(
        'inline-flex items-center gap-1.5 text-xs font-medium px-2 py-0.5 rounded-full',
        isLive
          ? 'bg-green-100 text-green-700'
          : 'bg-gray-100 text-gray-500',
        className
      )}
    >
      <span
        className={clsx(
          'h-2 w-2 rounded-full',
          isLive ? 'bg-green-500 animate-pulse' : 'bg-gray-400'
        )}
      />
      {isLive ? 'Live' : 'Offline'}
    </span>
  );
});

StatusBadge.displayName = 'StatusBadge';
